<template>
    <div>
        <div class="container" style="width:100%;">
            <div style="font-size:20px;"><i class="el-icon-s-unfold grid-con-icon"></i><span style="margin-left:5px;">服务管理</span></div>
            

            <el-divider content-position="left"><span style="font-size:larger;">类型</span></el-divider>
            <div class="card-group" style="display:flex;justify-content:space-around;"> 
                <div class="group-item" v-for="(item,groupIndex) in cateList" :key="groupIndex">
                    <div @click="onEdit(2,item)">
                        <el-card class="box-card"  shadow="hover">                            
                            <div  class="text item">
                                    <el-image
                                        style="width: 100px; height: 100px"
                                        :src="item.img"
                                        :fit="'scale-down'"></el-image>
                            </div>
                            <div class="clearfix product-name">{{item.name}}</div> 
                            <div class="desc">{{item.desc}}</div>
                        </el-card>
                    </div>
                </div>
            </div>

            <el-divider content-position="left" style="margin-top:15px;" ><span style="font-size:larger;">阶段</span></el-divider>
            <div class="card-group" style="display:flex;justify-content:space-around;"> 
                <div class="group-item" v-for="(item,groupIndex) in periodList" :key="groupIndex">
                    <div @click="onEdit(1,item)">
                        <el-card class="box-card"  shadow="hover">                            
                            <div  class="text item">
                                    <el-image
                                        style="width: 100px; height: 100px"
                                        :src="item.img"
                                        :fit="'scale-down'"></el-image>
                            </div>
                            <div class="clearfix product-name">{{item.name}}</div> 
                            <div class="desc">{{item.desc}}</div>
                        </el-card>
                    </div>
                </div>
            </div>


            <el-divider content-position="left" style="margin-top:15px;"><span style="font-size:larger;">客户等级</span></el-divider>
            <div class="card-group" style="display:flex;justify-content:space-around;"> 
                <div class="group-item" v-for="(item,groupIndex) in clientTypeList" :key="groupIndex">
                    <div @click="onEdit(3,item)">
                        <el-card class="box-card"  shadow="hover">                            
                            <div  class="text item">
                                    <el-image
                                        style="width: 100px; height: 100px"
                                        :src="item.img"
                                        :fit="'scale-down'"></el-image>
                            </div>
                            <div class="clearfix product-name" >{{item.name}}</div> 
                            <div class="desc">{{item.desc}}</div>
                        </el-card>
                    </div>
                </div>
            </div>

            <el-dialog :title="dialogTitle" :visible="listDialogVisible" v-if='listDialogVisible' width="70%"
                             :modal-append-to-body='false'                             
                             :close-on-click-modal='false'
                              @close="listDialogVisible = false" 
                             append-to-body>	
                <todo-detail style="margin-top:-40px;" :condition="condition"/>
				<div slot="footer" class="dialog-footer">
						<el-button @click="listDialogVisible = false">关闭</el-button>
						<!-- <el-button type="primary" @click="onSaveRemark">保存</el-button> -->
				</div>
		    </el-dialog>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import TodoDetail from "@/views/ZC/TodoDetail";

export default {
    name: 'baseform',
    components: {
        TodoDetail
      },
    computed: {
        ...mapGetters([])
    },
    data() {
        return {
            periodList:[{name:'1-3月',img:require('@/assets/sec1.png'),desc:'订单生效后前3个月需要跟进的任务'}
                ,{name:'4-6月',img:require('@/assets/sec2.png'),desc:'订单生效后4-6个月需要跟进的任务'}
                ,{name:'7-9月',img:require('@/assets/sec3.png'),desc:'订单生效后7-9个月需要跟进的任务'}
                ,{name:'10-12月',img:require('@/assets/sec4.png'),desc:'订单生效后10-12个月需要跟进的任务'}],
            cateList:[{name:'培训支持',img:require('@/assets/train.png'),desc:'订单周期内需要进行培训的服务'}
                ,{name:'产品服务',img:require('@/assets/productservice.png'),desc:'订单周期内需要进行的产品相关服务'}
                ,{name:'工单支持',img:require('@/assets/gdSupport.png'),desc:'工单业务支持'}
                ,{name:'续约服务',img:require('@/assets/xyService.png'),desc:'订单结束前跟进续约服务'}],
            clientTypeList:[{name:'核心客户',img:require('@/assets/hxkh.png'),desc:'订单量在80个坐席以上的订单服务'}
                ,{name:'重要客户',img:require('@/assets/zykh.png'),desc:'订单量在30~80个坐席的订单服务'}
                ,{name:'一般客户',img:require('@/assets/ybkh.png'),desc:'订单量在30个坐席以下的订单服务'}],

            listDialogVisible:false,
            dialogTitle:'',

            condition:{
                flag:0,
                name:''
            },

        };
    },

    async mounted() {

    },


    methods: {
        onEdit(flag,item){
            this.dialogTitle = item.name;
            this.condition.flag=flag;
            this.condition.name=item.name;
            // console.log('aa')
            this.listDialogVisible=true;
        },
    }
};
</script>

<style scoped>

.card-group{
    display:flex;
    flex-wrap:wrap;
    justify-content:center;
}
.group-item{
    /* padding: 20px; */
    margin-left: 10px;
    cursor: pointer;
}

.box-card {
    width: 300px;
    display:flex;
    flex-direction:column;
    justify-content:center;
  }

.desc{
    display: flex;
    justify-content: center;
    margin-top:5px;
    color: gray;
}
  .clearfix{
    /* margin-top: -5px; */
}

.product-name{
    font-size: x-large;
    display:flex;
    justify-content:center;
    cursor: pointer;
    color: #2F5597;
    /* margin-left:25px; */
    /* margin-top:-20px; */
}
   .text {
    font-size: 14px;
  }

  .item {
    /* margin-bottom: 18px; */
    /* margin-top:18px; */
    display:flex;
    justify-content:center;
  }

</style>